// extracted by mini-css-extract-plugin
export default {"container":"par_3RTFf","link":"par_lin_10TPu","frame":"par_fra_1687d","imageContainer":"par_ima_EdeRL","image":"par_ima_3zwok","background":"par_bac_WvXR9"};